/* Color groups use listing/option labels, never image pixels or filenames. */
(function (host) {
  'use strict';
  var palette = ['Black', 'White', 'Blue', 'Green', 'Orange', 'Red', 'Brown', 'Grey', 'Pink', 'Camouflage', 'Purple', 'Tan', 'Turquoise', 'Clear'];
  function colors(label) {
    var text = String(label || '').toLowerCase();
    var groups = [];
    var patterns = {
      Black: /\bblack\b/, White: /\bwhite\b/, Blue: /\b(blue|navy)\b/,
      Green: /\b(green|olive)\b/, Orange: /\borange\b/, Red: /\b(red|burgundy|burgandy)\b/,
      Brown: /\bbrown\b/, Grey: /\b(grey|gray|silver)\b/, Pink: /\b(pink|fuchsia)\b/,
      Camouflage: /\b(camouflage|camoflage|camo|multicam|ocp|acu|abu|nwu|tiger stripe)\b/,
      Purple: /\b(purple|concord)\b/, Tan: /\btan\b/, Turquoise: /\bturquoise\b/, Clear: /\bclear\b/
    };
    palette.forEach(function (group) { if (patterns[group].test(text)) groups.push(group); });
    return groups;
  }
  function selection(product, selected, format) {
    if (!selected.length && !format) return null;
    var matches = product.variants.filter(function (variant) {
      if (format && variant.format !== format) return false;
      if (!selected.length) return true;
      var labels = product.colorOption ? variant.color : product.listingColor !== undefined ? product.listingColor : product.title;
      var groups = colors(labels);
      return selected.some(function (color) { return groups.indexOf(color) !== -1; });
    }).sort(function (a, b) { return a.price - b.price; });
    if (!matches.length) return null;
    return { variant: matches[0], priceText: matches[0].money, from: matches.some(function (variant) { return variant.price !== matches[0].price; }) };
  }
  function queryUrl(input, selected, facets) {
    var url = new URL(input);
    url.searchParams.delete('filter.v.option.color');
    url.searchParams.delete('color');
    url.searchParams.delete('page');
    if (selected.length) url.searchParams.set('color', selected.join(','));
    url.searchParams.delete('format');
    if (facets) [['material', 'material'], ['format', 'sale_format']].forEach(function (pair) {
      url.searchParams.delete(pair[1]);
      if (facets[pair[0]]) url.searchParams.set(pair[1], facets[pair[0]]);
    });
    return url;
  }
  function isIllustration(src, alt) {
    return /nytarp-illustration-/i.test(src || '') || /^(?:generated )?illustration\b/i.test(alt || '');
  }
  function init(scope) {
    scope.querySelectorAll('[data-nytarp-color-browse]').forEach(function (root) {
      if (root.dataset.ready) return;
      var data;
      try { data = JSON.parse(root.querySelector('[data-color-browse-data]').textContent); } catch (error) { return; }
      var url = new URL(host.location.href);
      var selected = (url.searchParams.get('color') || url.searchParams.getAll('filter.v.option.color').join(',')).split(',').filter(Boolean);
      // Use an independent theme parameter so a later native filter configuration cannot discard shade aliases on the server.
      if (url.searchParams.has('filter.v.option.color') || (url.searchParams.has('page') && Number(root.dataset.total) <= 250)) {
        host.location.replace(queryUrl(url, selected).href);
        return;
      }
      var materialControl = root.querySelector('[data-material-browse-select]');
      var formatControl = root.querySelector('[data-format-browse-select]');
      var facets = { material: '', format: '' };
      function readFacets() {
        var current = new URL(host.location.href);
        [['material', materialControl, 'material'], ['format', formatControl, 'sale_format']].forEach(function (pair) {
          var value = current.searchParams.get(pair[2]) || '';
          facets[pair[0]] = pair[1] && Array.from(pair[1].options).some(function (option) { return option.value === value; }) ? value : '';
        });
      }
      readFacets();
      var control = root.querySelector('[data-color-browse-select]');
      var count = root.querySelector('[data-color-browse-count]');
      var reset = root.querySelector('[data-color-browse-reset]');
      var empty = root.querySelector('[data-color-browse-empty]');
      var cards = Array.from(root.querySelectorAll('[data-color-product]'));
      var originals = cards.map(function (card) { return card.innerHTML; });
      var complete = data.length >= Number(root.dataset.total);
      // A larger collection retains native pagination; never report a page-only color count as complete.
      if (!complete) {
        root.querySelector('[data-color-browse-controls]').hidden = true;
        count.textContent = root.dataset.incomplete;
        return;
      }
      root.dataset.ready = 'true';
      root.querySelector('[data-color-browse-controls]').hidden = false;
      root.querySelectorAll('[data-catalog-facets-controls]').forEach(function (element) { element.hidden = false; });
      function draw() {
        var visible = 0;
        var matchesById = {};
        cards.forEach(function (card, index) {
          var product = data.find(function (entry) { return String(entry.id) === card.dataset.colorProduct; });
          var match = product && selection(product, selected, facets.format);
          matchesById[card.dataset.colorProduct] = match;
          card.hidden = !!((selected.length || facets.format) && !match) || !!(facets.material && (!product || (product.families || []).indexOf(facets.material) === -1));
          if (card.hidden) return;
          visible += 1;
          card.innerHTML = originals[index];
          if (!match) return;
          var variant = match.variant;
          card.querySelector('a').href = variant.url;
          var media = card.querySelector('.nytarp-product-card__media');
          var image = media.querySelector('img');
          if (variant.image && image) {
            image.src = variant.image;
            image.removeAttribute('srcset');
            image.alt = variant.alt || [product.title, variant.color].filter(Boolean).join(' — ');
            image.width = variant.width || 1200;
            image.height = variant.height || 1200;
          } else if (!variant.image && selected.length) {
            media.textContent = root.dataset.photoUnavailable;
          }
          var price = card.querySelector('.nytarp-product-card__price');
          price.textContent = (match.from ? root.dataset.from + ' ' : '') + match.priceText;
          var unit = card.querySelector('[data-card-unit]');
          if (unit) unit.textContent = variant.unit;
          var caption = card.querySelector('[data-card-caption]');
          if (caption) {
            if (variant.caption) caption.textContent = variant.caption;
            caption.hidden = !variant.caption && !isIllustration(variant.image, variant.alt);
          }
          var option = card.querySelector('[data-card-selection]');
          if (option) { option.textContent = variant.label || ''; option.hidden = !product.colorOption || !variant.label || variant.label === 'Default Title'; }
        });
        var ordered = cards.slice();
        if ((selected.length || facets.format || facets.material) && sort && /^(price-ascending|price-descending)$/.test(sort.value)) {
          var direction = sort.value === 'price-ascending' ? 1 : -1;
          ordered.sort(function (a, b) {
            var first = matchesById[a.dataset.colorProduct];
            var second = matchesById[b.dataset.colorProduct];
            if ((!first || !second) && (first || second)) return first ? -1 : 1;
            if (!first && !second) {
              var firstProduct = data.find(function (entry) { return String(entry.id) === a.dataset.colorProduct; });
              var secondProduct = data.find(function (entry) { return String(entry.id) === b.dataset.colorProduct; });
              return direction * (Math.min.apply(null, firstProduct.variants.map(function (variant) { return variant.price; })) - Math.min.apply(null, secondProduct.variants.map(function (variant) { return variant.price; })));
            }
            return direction * (first.variant.price - second.variant.price);
          });
        }
        ordered.forEach(function (card) { card.parentElement.appendChild(card); });
        var labels = selected.slice();
        [[facets.material, materialControl], [facets.format, formatControl]].forEach(function (pair) {
          if (!pair[0] || !pair[1]) return;
          var option = Array.from(pair[1].options).find(function (entry) { return entry.value === pair[0]; });
          if (option) labels.push(option.textContent);
        });
        count.textContent = visible + ' ' + (visible === 1 ? root.dataset.productSingular : root.dataset.productPlural) + (labels.length ? ' · ' + labels.join(' · ') : '');
        empty.hidden = visible !== 0;
        reset.hidden = selected.length === 0 && !facets.material && !facets.format;
        control.value = selected.length === 1 && palette.indexOf(selected[0]) !== -1 ? selected[0] : '';
        if (materialControl) materialControl.value = facets.material;
        if (formatControl) formatControl.value = facets.format;
        root.dispatchEvent(new host.CustomEvent('nytarp:catalog-updated', { bubbles: true, detail: { products: ordered.filter(function (card) { return !card.hidden; }).map(function (card) {
          var product = data.find(function (entry) { return String(entry.id) === card.dataset.colorProduct; });
          return { id: product.id, title: product.title, url: card.querySelector('a').href };
        }) } }));
      }
      var sort = root.querySelector('[data-color-browse-sort]');
      if (sort) sort.addEventListener('change', function () {
        var target = queryUrl(host.location.href, selected, facets);
        target.searchParams.set('sort_by', sort.value);
        host.location.assign(target.href);
      });
      control.addEventListener('change', function () {
        selected = control.value ? [control.value] : [];
        host.history.replaceState(null, '', queryUrl(host.location.href, selected, facets));
        draw();
      });
      [[materialControl, 'material'], [formatControl, 'format']].forEach(function (pair) {
        if (!pair[0]) return;
        pair[0].addEventListener('change', function () {
          facets[pair[1]] = pair[0].value;
          host.history.replaceState(null, '', queryUrl(host.location.href, selected, facets));
          draw();
        });
      });
      reset.addEventListener('click', function () {
        selected = [];
        facets.material = '';
        facets.format = '';
        host.history.replaceState(null, '', queryUrl(host.location.href, [], facets));
        draw();
        control.focus();
      });
      host.addEventListener('popstate', function () {
        selected = (new URL(host.location.href).searchParams.get('color') || '').split(',').filter(Boolean);
        readFacets();
        draw();
      });
      draw();
    });
    scope.querySelectorAll('[data-nytarp-image-caption]').forEach(function (caption) {
      if (caption.dataset.ready) return;
      var image = scope.querySelector('#' + caption.dataset.imageId);
      if (!image) return;
      caption.dataset.ready = 'true';
      function update() { caption.hidden = !caption.dataset.generatedCaption && !isIllustration(image.getAttribute('src'), image.getAttribute('alt')); }
      new MutationObserver(update).observe(image, { attributes: true, attributeFilter: ['src', 'alt'] });
      update();
    });
  }
  var api = { colors: colors, selection: selection, queryUrl: queryUrl, isIllustration: isIllustration, init: init };
  if (typeof module !== 'undefined') module.exports = api;
  if (!host || !host.document) return;
  host.NYTarpColorBrowse = api;
  if (host.document.readyState === 'loading') host.document.addEventListener('DOMContentLoaded', function () { init(host.document); });
  else init(host.document);
  host.document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})(typeof window === 'undefined' ? null : window);
